import { RestrictedArea, ROLES } from "containers/Permissions";

import { VariantPublicationForm } from "../components";
import { PublicationsSubTabProps } from "../types";

export function TiVoAppDetailsPublicationsEditSubTab({
  platforms,
  publication,
}: PublicationsSubTabProps) {
  return (
    <RestrictedArea allowed={[ROLES.tivo.moderator]}>
      {publication.platforms.map((platform) => {
        return (
          <VariantPublicationForm
            key={`${platform.platformId}-form`}
            platform={platform}
            platforms={platforms}
            publication={publication}
          />
        );
      })}
    </RestrictedArea>
  );
}
